import React from 'react';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { Row, Collapse, Button } from 'antd';
import { NextPage } from 'next';

const { Panel } = Collapse;

interface IQuestion {
  question: string;
  answer: string;
}
interface IFaqs {
  id: string;
  title: string;
  questions: IQuestion[];
}

interface OwnProps {
  data: Array<IFaqs>;
}

const FaqsAccordion: NextPage<OwnProps, {}> = ({ data }): JSX.Element => {
  //TODO Implement
  const handleExpandAll = () => {};

  const expandButton = (index) =>
    index === 0 ? (
      <Button
        className="faqsAccordion--expandAll"
        type="primary"
        danger
        onClick={handleExpandAll}
      >
        Expand All
      </Button>
    ) : null;

  const renderQuestions = (id: string, questions: IQuestion[]) => {
    return questions.map((questionData, index) => {
      const { question, answer } = questionData;
      return (
        <div className="faqsAccordion__container">
          <Collapse
            accordion
            className="faqsAccordion__collapse"
            expandIcon={() => (
              <QuestionCircleOutlined style={{ fontSize: '1.6rem' }} />
            )}
          >
            <Panel
              forceRender
              className="faqsAccordion__panel"
              header={<span className="regular-body">{question}</span>}
              key={id.concat(index.toString())}
            >
              <span className="regular-body">{answer}</span>
            </Panel>
          </Collapse>
        </div>
      );
    });
  };

  const renderAccordion = () => {
    return data.map((data, index) => {
      const { id, title, questions } = data;
      return (
        <div className="faqsAccordion">
          <Row className="faqsAccordion__wrapper">
            <span className="section-title">{title}</span>
            {expandButton(index)}
          </Row>
          {renderQuestions(id, questions)}
        </div>
      );
    });
  };

  return <>{renderAccordion()}</>;
};

export default FaqsAccordion;
